import { render, staticRenderFns } from "./SettingsProfile.vue?vue&type=template&id=3d4d4496"
import script from "./SettingsProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsProfile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports